import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';


import { getReportTotalInternalByCountry, reportTotalInternalByCountry, reportDetailInternal } from '@actions/users';
import { validatePermissionAction } from '@actions/sessionPermission';

import catalogPermissionsId from '@constants/catalogPermissionsId';

class ReportUsersInternal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: true,
      loadingBtn1: false,
      loadingBtn2: false,
      fullData: [],
      data: [],
      lazyParams: {
        first: 0,
        rows: 7,
        page: 0,
      }
    };
  }

  async componentDidMount() {
    await this.loadData();
  }

  loadData = async () => {
    const { getReportTotalInternalByCountry } = this.props;
    this.setState({ loadingTable: true });
    const response = await getReportTotalInternalByCountry();
    if (!response?.status) {
      return this.setState({
        fullData: response.data,
        data: response.data,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };

  onTotalInternalByCountry = async () => {
    const { reportTotalInternalByCountry } = this.props;
    this.setState({ loadingBtn1: true });
    await reportTotalInternalByCountry();
    this.setState({ loadingBtn1: false });
  };

  onDetailInternal = async () => {
    const { reportDetailInternal } = this.props;
    this.setState({ loadingBtn2: true });
    await reportDetailInternal();
    this.setState({ loadingBtn2: false });
  };

  loadDataByPage = () => {
    const { lazyParams, fullData } = this.state
    const dataPage = fullData.slice(lazyParams.first, (lazyParams.first + lazyParams.rows))
    this.setState({ data: dataPage })
  }

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    this.setState({ lazyParams: _lazyParams }, this.loadDataByPage);
  };

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  render() {
    const { t, history, validatePermissionAction } = this.props;
    const { fullData, data, loadingTable, loadingBtn1, loadingBtn2, lazyParams } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        <Button
          label={t('Regresar')}
          className="p-button-primary"
          onClick={() => history.push('/reports')}
        />
      </>
    );

    return (
      <div className="p-grid p-justify-center">
        <div className="p-col-12">
          <Header title={t('Usuarios internos')} rightComponent={rightHeader} />
          <p>{t('Total de usuarios internos registrados por país')}</p>
        </div>
        
        <div className="p-col-12 p-lg-8 p-mt-2">
          <div className="card">
            <div className="p-text-right ">
              <Button
                label={t('Total usuarios por país')}
                className="p-button p-button-outlined p-button-prymary p-component p-button-rounded p-mt-3 p-mb-4 p-mr-3"
                onClick={this.onTotalInternalByCountry}
                loading={loadingBtn1}
                icon='pi pi-download'
                // tooltip='Descarga xls'
              />
              { validatePermissionAction(catalogPermissionsId.ACCESO_DETALLE_REPORTES) && (
                <Button
                  label={t('Detalle de usuarios')}
                  className="p-button p-button-outlined p-button-secondary p-component p-button-rounded p-mt-3 p-mb-4"
                  onClick={this.onDetailInternal}
                  loading={loadingBtn2}
                  icon='pi pi-download'
                  // tooltip='Descarga xls'
                />
              )}
            </div>
            <DataTable
              value={data}
              lazy
              loading={loadingTable}
              onPage={this.onPage}
              paginator={!!fullData.length}
              rows={lazyParams.rows}
              totalRecords={fullData.length}
              first={lazyParams.first}
              showGridlines
              stripedRows
            >
              <Column
                header={t('País')}
                field="pais"
                body={this.columnResponsive}
              />
              <Column
                header={t('Total')}
                field="total"
                body={this.columnResponsive}
              />
              <Column
                header={t('Registrados')}
                field="registrados"
                body={this.columnResponsive}
              />
              <Column
                header={t('Porcentaje')}
                field="porcentaje"
                body={this.columnResponsive}
              />
              
            </DataTable>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
  getReportTotalInternalByCountry,
  reportTotalInternalByCountry,
  reportDetailInternal,
  validatePermissionAction
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ReportUsersInternal);
